import gridMixin from 'v/Story/Timeline/view/grid.mixin';
import { mapActions, mapState } from 'vuex';
import tmBus from 'v/Story/Timeline/api/tmBus';
import {
  assignDurations,
  CursorManager,
  getResizeAvailability,
  mapAvailability2Cursor,
} from 'v/Story/Timeline/api/tapi';
import { getAudioResizeWindow } from 'v/Story/Timeline/api/asset';
import fg from '#/libs/FrameGrid';

export default {
  mixins: [gridMixin],
  computed: {
    ...mapState('timemachine', {
      MODE_SCENE_EDIT: (state) => state.MODE.SCENE_EDIT,
      secondhand: (state) => state.secondhand,
    }),

    moveObj() {
      return {
        enabled: !this.MODE_SCENE_EDIT,
        distance2trigger: this.CONST.DND_SENSITIVITY.RESIZE,
        onMoveStart: this.$_onMoveStart,
        onMove: this.$_onMove,
        onMoveEnd: this.$_onMoveEnd,
      };
    },
  },

  methods: {
    ...mapActions('timemachine', [
      'SET_MODE',
      'SET_DND_ESCORT',
      'SELECT_AUDIO',
      'SET_AUDIO_LAYER_DURATION',
      'RECALCULATE_ROWS',
    ]),

    $_onMoveStart(state) {
      this.SET_MODE({ name: 'AUDIO_RESIZE', value: true });
      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: true });
      this.SELECT_AUDIO({ track: this.$props.track });
      this.$props.track.isResizing = true;
      this.$props.track.resizeEscort.fromLeft = this.$props.fromLeft;

      state.mousePoint = this.$_mouse2point(state.eDown);

      const { data } = this.$props.track;
      state.initial = assignDurations({}, data);
      state.maxTimeShifted = state.initial.displayEndTime;
      state.mousePoint = this.$_mouse2point(state.eDown);
      const resizeWindow = getAudioResizeWindow(this.$props.track);
      const trackIndex = this.trackLayer.audio.indexOf(this.$props.track);

      if (this.$props.fromLeft) {
        state.shiftX = this.rectangle.p1.x - state.mousePoint.x;
        state.resizeWindow = resizeWindow.left;

        if (trackIndex > 0) {
          state.resizeWindow.min = Math.max(
            state.resizeWindow.min,
            this.trackLayer.audio[trackIndex - 1].data.displayEndTime
          );
        }
      } else {
        state.shiftX = this.rectangle.p2.x - state.mousePoint.x;
        state.resizeWindow = resizeWindow.right;

        if (trackIndex < this.trackLayer.audio.length - 1) {
          state.resizeWindow.max = Math.min(
            state.resizeWindow.max,
            this.trackLayer.audio[trackIndex + 1].data.displayStartTime
          );
        }
      }

      const aTimes = [this.secondhand];
      state.proximityTester = this.$_createProximityTester(
        aTimes,
        this.CONST.AUTOSNAP_PROXIMITY.RESIZE
      );

      tmBus.$emit('callbackBeforeDragStarts');
      tmBus.$emit('callbackAudioAssetResizeStart');
    },

    $_onMove(state) {
      this.$_mouse2point(state.eMove, state.mousePoint, state.shiftX);

      let curTime = state.mousePoint.time;
      const snapTime = state.proximityTester.find(curTime);
      if (null !== snapTime) {
        curTime = snapTime;
      }
      state.curTime = _.constrain(
        state.resizeWindow.min,
        curTime,
        state.resizeWindow.max
      );

      if (this.$props.fromLeft) {
        this.$_moveFromLeft(state);
      } else {
        this.$_moveFromRight(state);
      }

      const resizeWindow = getAudioResizeWindow(this.$props.track);
      const availability = getResizeAvailability(
        resizeWindow,
        this.$props.track.data
      );
      const cursorMap = mapAvailability2Cursor(availability);
      CursorManager.set(
        this.$props.fromLeft ? cursorMap.left : cursorMap.right
      );
    },

    $_moveFromLeft(state) {
      const { data } = this.$props.track;
      data.displayStartTime = fg.trunc(state.curTime);
      const newDuration = data.displayEndTime - state.curTime;
      data.relativeStartTime = fg.trunc(data.relativeEndTime - newDuration);
    },

    $_moveFromRight(state) {
      const { data } = this.$props.track;
      data.displayEndTime = fg.ceil(state.curTime);
      const newDuration = state.curTime - data.displayStartTime;
      data.relativeEndTime = fg.ceil(data.relativeStartTime + newDuration);

      if (state.curTime > state.maxTimeShifted) {
        state.maxTimeShifted = state.curTime;
        this.SET_AUDIO_LAYER_DURATION();
        this.RECALCULATE_ROWS();
      }
    },

    $_onMoveEnd(state) {
      CursorManager.restore();

      const { data } = this.$props.track;

      if (state.canceled) {
        assignDurations(data, state.initial);
      }

      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: false });
      this.SET_MODE({ name: 'AUDIO_RESIZE', value: false });
      this.$props.track.isResizing = false;
      this.SET_AUDIO_LAYER_DURATION();
      this.RECALCULATE_ROWS();

      tmBus.$emit('callbackChange', { e: state.eUp });
    },
  },
};
